export interface FlightRoutingItem {
  key: string;
}

export enum TripType {
  Oneway = "oneway",
  RountTrip = "roundTrip",
  MultiCities = "multy-Cities",
}

export enum CabinType {
  // All = "A",
  Economy = "Y",
  Business = "C",
  First = "F",
  PremiumEconomy = "S",
  PremiumBusiness = "J",
  PremiumFirst = "P",
}

export interface IFlightQuery {
  tripType: TripType;
  cabin?: CabinType;
  adults: number;
  children?: number;
  infants?: number;
  trips: string;
}

export interface IMultyTripItem {
  origin: string;
  destination: string;
  departureDate: string;
}
